import { render, staticRenderFns } from "./gzzoc-glaucoma.vue?vue&type=template&id=48543360&scoped=true&lang=pug&"
import script from "./gzzoc-glaucoma.vue?vue&type=script&lang=js&"
export * from "./gzzoc-glaucoma.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-glaucoma.vue?vue&type=style&index=0&id=48543360&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48543360",
  null
  
)

export default component.exports